import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import {ErrorService} from "./error.service";
import {NotificationService} from "./notification.service";
import {LoggingService} from "./logging.service";
import { EhrErrorHandlerService } from "@ehrCore/errors/service/ehr-error-handler.service";
import { EhrBaseError } from "@ehrCore/errors/ehr.error";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) { }

  handleError(error: Error | HttpErrorResponse) {
    const errorService = this.injector.get(ErrorService);
    const logger = this.injector.get(LoggingService);
    const notifier = this.injector.get(NotificationService);
    const ehrErrorHandler = this.injector.get(EhrErrorHandlerService);

    // handle ehr errors
    if (error instanceof EhrBaseError) {
      ehrErrorHandler.handleError(error);
      return;
    }

    let message;
    let stackTrace;
    if (error instanceof HttpErrorResponse) {
      message = errorService.getServerErrorMessage(error);
      notifier.showError(message);
    }

    logger.logError(message, stackTrace);
    console.error(error);
  }
}
